
import Vue from "vue";
import { Task } from "../../models/tasks/task";
import AppInfoLabel from "@/components/common/InfoInput.vue";
import { DossierService } from "../../services/dossier-service";
import { FolderUser } from "../../models/tasks/folder-user";
import { printLocalDateTime } from "../../utils/pretty-print";

export default Vue.extend({
	props: {
		task: {
			type: Object as ()=>Task,
			required: true
		},
		folder: {
			type: Object as ()=>FolderUser,
			required: true
		}
	},
	computed: {
		assignedUsers():string{
			return this.task.AssignedUsers.map(u=>DossierService.getUser(u.UserID).getUserString()).join(", ") || this.$ct("common.empty").toString();
		},
		statusString():string{
			return this.$ct(`models.TaskStatuses.${this.task.Status}`).toString();
		},
		dueDateString():string{
			return printLocalDateTime(this.task.DueDate);
		}
	},
	methods: {
		close(){
			this.$emit("close");
		}
	},
	components: {
		AppInfoLabel
	},
	i18nEx: {
		componentPrefix: "components.calendar"
	}
});
